var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"dialog-drag",rawName:"v-dialog-drag"}],staticClass:"desk-flag-add",style:({ bottom: _vm.$route.meta.showTabs ? '59px' : '10px' })},[_c('div',{staticClass:"desk-flag-btn",on:{"click":_vm.deskHandle}},[_c('img',{attrs:{"src":require("@/assets/images/plat-logo.png"),"alt":""}}),_vm._v(" "),_c('span',[_vm._v("下载到桌面")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7263572c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeskFlagAdd.vue
// module id = null
// module chunks = 